import React from 'react';

//Redux
import { useSelector } from 'react-redux';
import TablaDatosCuotaFraccion from './TablaDatosCuotaFraccion';
import TablaDatosPension from './TablaDatosPension';

const TablaPensionFraccion = ({pension, detallePago}) => {
  
  const cuotasPensiones = pension;
  const { modalidad, idPensionFraccion } = detallePago;
 //console.log(pension,detallePago)
  //En caso de que el pago sea de una fracción
  const obtenerFraccion = () => {
    const cuotas = cuotasPensiones.cuotas;
    const cuotaPagar = cuotas.find(cuota => cuota.id_fraccion === idPensionFraccion);
    return cuotaPagar;
  }

  const mostrarTabla = () => {
    if(modalidad === 'fraccion'){
      const resultado = obtenerFraccion();
      return <TablaDatosCuotaFraccion
        {...resultado}
      />
    }
    return <TablaDatosPension
      pension={cuotasPensiones}
    />
  }

  return ( 
    <> 
      {mostrarTabla()}
    </>
  );
}
 
export default TablaPensionFraccion;